var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabs-wrapper"},[_c('b-tabs',{attrs:{"lazy":""}},[_c('b-tab',{attrs:{"title":"Total"}},[_c('div',{staticClass:"kpi-content"},[_c('ulu-finance-kpi-types')],1)])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }